
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUserAccountDto } from '@my-aon/auth';
import { SharedModule } from '@my-aon/shared';
import { FormResetMfaComponent } from '../../components/form-reset-mfa/form-reset-mfa.component';

@Component({
    selector: 'lib-dialog-reset-mfa',
    templateUrl: './dialog-reset-mfa.component.html',
    styleUrl: './dialog-reset-mfa.component.scss',
    standalone: true,
    imports: [SharedModule, FormResetMfaComponent],
})
export class DialogResetMfaComponent {
    readonly dialogRef = inject<MatDialogRef<DialogResetMfaComponent>>(MatDialogRef);
    readonly data = inject<{ data: IUserAccountDto }>(MAT_DIALOG_DATA);

    submited: boolean = false;

    get promptParams() {
        return {
            name: this.escapeHtml(this.data.data.Name),
            email: this.escapeHtml(this.data.data.Email),
        };
    }

    close = (e: IUserAccountDto | null): void => {
        this.dialogRef.close(e);
    };

    onSubmit = (e?: any): void => {
        if (this.submited === false) this.submited = true;
    };

    private escapeHtml(value: string | null | undefined): string {
        if (!value) return '';
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}
